import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import LabelComponent from "pages/profile/common/label";
import { ReactComponent as EditIcon } from "images/profile/edit-icon.svg";

function CompanyDetailsDisplay({
  onEditClick = () => {},
  isShowEditIcon = false,
}) {
  const [t] = useTranslation();
  const userDetails = useSelector((state) => state.userDetails || {});
  const [isEditShowEditOnHover, setShowEditOnHover] = useState(false);

  return (
    <div
      id="companyDetailsSection"
      className={`flex p-[24px] flex-col gap-[12px] self-stretch cursor-pointer ${
        isEditShowEditOnHover ? "bg-[#F3F5F7]" : ""
      }`}
      onMouseEnter={() => setShowEditOnHover(true)}
      onMouseLeave={() => setShowEditOnHover(false)}
    >
      <div className="flex justify-between items-center self-stretch">
        <div className="text-[#1D1B22] font-semibold text-[24px]">
          {t("companyInformation")}
        </div>
        {isShowEditIcon && (
          <EditIcon
            className={`cursor-pointer ${
              isEditShowEditOnHover ? "visible" : "invisible"
            }`}
            onClick={onEditClick}
          />
        )}
      </div>

      <div className="flex flex-wrap gap-[20px]">
        <LabelComponent
          title={t("companyName")}
          subTitle={userDetails?.companyName || "-"}
        />
        <LabelComponent
          title={t("country")}
          subTitle={userDetails?.country?.name || "-"}
        />
        <LabelComponent
          title={t("city")}
          subTitle={userDetails?.city?.name || "-"}
        />
        <LabelComponent
          title={t("website")}
          subTitle={userDetails?.companyWebsite || "-"}
        />
        <LabelComponent
          title={t("companyEmail")}
          subTitle={userDetails?.email || "-"}
        />

        <LabelComponent
          title={t("phoneNumber")}
          subTitle={userDetails?.phone || "-"}
        />
        <LabelComponent
          title={t("representativeName")}
          subTitle={userDetails?.representativeName || "-"}
        />
      </div>
    </div>
  );
}

CompanyDetailsDisplay.propTypes = {
  onEditClick: PropTypes.func.isRequired,
  isShowEditIcon: PropTypes.bool,
};

export default CompanyDetailsDisplay;
